import services  from '../services';

export const appConfigActions = {
    loadEnvProperties,
};

function loadEnvProperties(){
    return services.appConfigService.loadEnvPropertyService();
}